/**
 * Product Detail Utilities
 */

import { generateSlug } from "../../../utils/slugUtils";

/**
 * Utility function to get product key from title
 */
export const getProductKey = (title) => {
  const slug = generateSlug(title);
  // Convert slug to camelCase for JSON key
  return slug.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
};
